import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Language} from "../models/Language";
import {environment} from "../../../environments/environment";
import {Country} from "../models/Country";

@Injectable({ providedIn: 'root' })
export class LocalService {
  private readonly baseUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.baseUrl = environment.local;
  }

  public getAvailableLanguages = () => this.httpClient.get<Language[]>(
    `${this.baseUrl}/languages.json`
  );

  public getCountries = () => this.httpClient.get<Country[]>(
    `${this.baseUrl}/countries.json`
  );

  public getNationalities = () => this.httpClient.get<string[]>(
    `${this.baseUrl}/nationalities.json`
  );

}
